import React from 'react'
import ArticleV2DrawerSection from './ArticleV2DrawerSection';
import {AnimateSharedLayout } from 'framer-motion';

const ArticleV2DrawerContentSection = ({data, idx}) => {
    data = data || [];

    return (
        <div>
            <AnimateSharedLayout>
                
                {data.map((section, idx) => {
                    const key = `sec-${idx}-${section.id}`;
                    return <ArticleV2DrawerSection key={key} data={section}/>
                })}
            </AnimateSharedLayout>

            <style jsx>{`
                div {
                    position: relative;
                    z-index: 1;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2DrawerContentSection